<template>
  <div id="app">

    <button variant="primary" @click="download" class="btn btn-primary">print</button>

    <table>
      <tr class="n1">
        <td align="left"><b>①免許証種類</b></td>
        <td align="right"><b> ：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n1" :key="'n1' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n1-' + index" :value="index" v-model="ob.n1">
            <label class="custom-control-label" :for="'check-n1-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n1 }}</span> -->
        </td>
      </tr>
      <tr class="n2">
        <td align="left"><b>②免許証番号</b></td>
        <td align="right"><b> ：</b></td>
        <td>
          <b-form-input v-model="ob.n2" :id="n2" type="number" placeholder="免許証番号"></b-form-input>
        </td>
      </tr>
      <tr class="n3">
        <td align="left"><b>③申請者氏名</b></td>
        <td align="right"><b> 名前：</b></td>
        <td><b-form-input v-model="ob.n3_3" placeholder="名前"></b-form-input></td>
      </tr>
      <tr class="n3">
        <td align="left"><b></b></td>
        <td align="right"><b> カタカナ：</b></td>
        <td><b-form-input v-model="ob.n3_2" placeholder="名前">,</b-form-input></td>
      </tr>
      <tr class="n3">
        <td align="left"><b></b></td>
        <td align="right"><b>小文字区分：</b></td>
        <td>
          <tr class="form-inline">
              <td width=30 v-for="(pos,index) in this.$pa.n3_1" :key="'n3_1' + index" class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" :id="'check-n3_1-' + index" :value="index" v-model="ob.n3_1"><label class="custom-control-label" :for="'check-n3_1-' + index"></label>
              </td>
          </tr>  
          <tr>
              <td width=30 v-for="(pos,index) in this.$pa.n3_1" :key="'n3_1' + index" class="">
                <span>{{ ob.n3_2[index] }}</span>
              </td>
          </tr>  
        </td>
      </tr>
      <tr class="n3">
        <td align="left"><b></b></td>
        <td align="right"><b> 変更：</b></td>
        <td>
          <div v-for="(pos,index) in this.$pa.n3_4" :key="'n3_4' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n3_4-' + index" :value="index" v-model="ob.n3_4">
            <label class="custom-control-label" :for="'check-n3_4-' + index"></label>
          </div>
          <!-- <span>Checked names: {{ ob.n3_4 }}</span> -->
        </td>
      </tr>
      <tr class="n4">
        <td align="left"><b>④申請者住所</b></td>
        <td align="right"><b> 郵便番：</b></td>
        <td><b-form-input v-model="ob.n4_1" placeholder="都道府県名"></b-form-input></td>
      </tr>
      <tr class="n4">
        <td align="left"><b></b></td>
        <td align="right"><b> 電話番号：</b></td>
        <td><b-form-input v-model="ob.n4_2" placeholder="電話番号"></b-form-input></td>
      </tr>
      <tr class="n4">
        <td align="left"><b></b></td>
        <td align="right"><b> 都道府県名：</b></td>
        <td><b-form-input v-model="ob.n4_3" placeholder="都道府県名"></b-form-input></td>
      </tr>
      <tr class="n4">
        <td align="left"><b></b></td>
        <td align="right"><b> 住所：</b></td>
        <td><b-form-input v-model="ob.n4_5" placeholder="住所"></b-form-input></td>
      </tr>
      <tr class="n4">
        <td align="left"><b></b></td>
        <td align="right"><b> 変更：</b></td>
        <td>
          <div v-for="(pos,index) in this.$pa.n4_6" :key="'n4_6' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n4_6-' + index" :value="index" v-model="ob.n4_6">
            <label class="custom-control-label" :for="'check-n4_6-' + index"></label>
          </div>
          <!-- <span>Checked names: {{ ob.n4_6 }}</span> -->
        </td>
      </tr>
      <tr class="n5">
        <td align="left"><b>⑤出生年月日</b></td>
        <td align="right"><b>元号：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n5_1" :key="'n5_1' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n5_1-' + index" :value="index" v-model="ob.n5_1">
            <label class="custom-control-label" :for="'check-n5_1-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n5_1 }}</span> -->
        </td>
      </tr>
      <tr class="n5">
        <td align="left"><b></b></td>
        <td align="right"><b> 西暦：</b></td>
        <td><b-form-input v-model="ob.n5_2" placeholder="西暦"></b-form-input></td>
      </tr>
      <tr class="n5">
        <td align="left"><b></b></td>
        <td align="right"><b> 生年月日：</b></td>
        <td><b-form-input v-model="ob.n5_3" placeholder="生年月日"></b-form-input></td>
      </tr>
      <tr class="n6">
        <td align="left"><b>⑤性別</b></td>
        <td align="right"><b>：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n6" :key="'n6' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n6-' + index" :value="index" v-model="ob.n6">
            <label class="custom-control-label" :for="'check-n6-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n5_1 }}</span> -->
        </td>
      </tr>
      <tr class="n7">
        <td align="left"><b>⑦本籍の都道府県名</b></td>
        <td align="right"><b> 都道府県名：</b></td>
        <td><b-form-input v-model="ob.n7_1" placeholder="都道府県名"></b-form-input></td>
      </tr>
      <tr class="n7">
        <td align="left"><b></b></td>
        <td align="right"><b> 変更：</b></td>
        <td>
          <div v-for="(pos,index) in this.$pa.n7_3" :key="'n7_3' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n7_3-' + index" :value="index" v-model="ob.n7_3">
            <label class="custom-control-label" :for="'check-n7_3-' + index"></label>
          </div>
          <!--  <span>Checked names: {{ ob.n7_3 }}</span> -->
        </td>
      </tr>
      <tr class="n5">
        <td align="left"><b>⑧国籍</b></td>
        <td align="right"><b>国籍選択：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n8_1" :key="'n8_1' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n8_1-' + index" :value="index" v-model="ob.n8_1">
            <label class="custom-control-label" :for="'check-n8_1-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n8_1 }}</span> -->
        </td>
      </tr>
      <tr class="n8">
        <td align="left"><b></b></td>
        <td align="right"><b> 国籍コード：</b></td>
        <td><b-form-input v-model="ob.n8_2" placeholder="国籍コード"></b-form-input></td>
      </tr>
      <tr class="n8">
        <td align="left"><b></b></td>
        <td align="right"><b> 変更：</b></td>
        <td>
          <div v-for="(pos,index) in this.$pa.n8_3" :key="'n8_3' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n8_3-' + index" :value="index" v-model="ob.n8_3">
            <label class="custom-control-label" :for="'check-n8_3-' + index"></label>
          </div>
          <!--  <span>Checked names: {{ ob.n8_3 }}</span> -->
        </td>
      </tr>
      <tr class="n9">
        <td align="left"><b>⑨申請月日</b></td>
        <td align="right"><b> ：</b></td>
        <td><b-form-input v-model="ob.n9" placeholder="9999"></b-form-input></td>
      </tr>
      <tr class="n10">
        <td align="left"><b>⑩特例申請</b></td>
        <td align="right"><b>：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n10" :key="'n10' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n10-' + index" :value="index" v-model="ob.n10">
            <label class="custom-control-label" :for="'check-n10-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n10 }}</span> -->
        </td>
      </tr>
      <tr class="n11">
        <td align="left"><b>⑪更新要件</b></td>
        <td align="right"><b>：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n11" :key="'n11' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n11-' + index" :value="index" v-model="ob.n11">
            <label class="custom-control-label" :for="'check-n11-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n11 }}</span> -->
        </td>
      </tr>
      <tr class="n12">
        <td align="left"><b>⑫講習機関</b></td>
        <td align="right"><b> コード：</b></td>
        <td><b-form-input v-model="ob.n12" placeholder="コード"></b-form-input></td>
      </tr>
      <tr class="n13">
        <td align="left"><b>⑬講習実施都道府県</b></td>
        <td align="right"><b> コード：</b></td>
        <td><b-form-input v-model="ob.n13" placeholder="コード"></b-form-input></td>
      </tr>
      <tr class="n14">
        <td align="left"><b>⑭講習実施年月日</b></td>
        <td align="right"><b> 年月日：</b></td>
        <td><b-form-input v-model="ob.n14" placeholder="年月日"></b-form-input></td>
      </tr>
      <tr class="n15">
        <td align="left"><b>⑮更新地方運輸局等</b></td>
        <td align="right"><b> 本局コード：</b></td>
        <td><b-form-input v-model="ob.n15_1" placeholder="本局コード"></b-form-input></td>
      </tr>
      <tr class="n15">
        <td align="left"><b></b></td>
        <td align="right"><b> 支局コード：</b></td>
        <td><b-form-input v-model="ob.n15_2" placeholder="支局コード"></b-form-input></td>
      </tr>
      <tr class="n16">
        <td align="left"><b>⑯免許証生年月日</b></td>
        <td align="right"><b> 年月日：</b></td>
        <td><b-form-input v-model="ob.n16" placeholder="年月日"></b-form-input></td>
      </tr>
      <tr class="n17">
        <td align="left"><b>⑰免許証返納の有無</b></td>
        <td align="right"><b>：</b></td>
        <td>
          <div class="form-inline" >
          <div v-for="(pos,index) in this.$pa.n17" :key="'n17' + index" class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" :id="'check-n17-' + index" :value="index" v-model="ob.n17">
            <label class="custom-control-label" :for="'check-n17-' + index">{{ pos.lb}}　</label>
          </div>
          </div>
          <!--<span>Checked names: {{ ob.n17 }}</span> -->
        </td>
      </tr>
    </table>  

    <div id="print" class="A4">
      <div class="pageout"><PrintElement v-bind:ob="ob" ref="printaa" /></div>
      <div class="preview"><PrintElement v-bind:ob="ob" /></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue' // add
import 'bootstrap/dist/css/bootstrap.css' // add
import 'bootstrap-vue/dist/bootstrap-vue.css' // add
Vue.use(BootstrapVue) // add
Vue.config.productionTip = false

import InputDataElement from "./components/InputData";
import PrintElement from "./components/Print";

import { createPdfFromHtml } from "./logic.js";


export default {
  name: "App",
  data () {
    return {
      ob:{
        n1: [],
        n2: "1234567890123",
        n3_1: [],
        n3_2: "ﾔﾏﾀﾞ ｼﾞｭﾝｲﾁﾛｳ",
        n3_3: "山田 純一郎",
        n3_4: false,
        n4_1: "9522203",
        n4_2: "09047506130",
        n4_3: "新潟",
        n4_5: "佐渡市関589",
        n4_6: false,
        n5_1: [],
        n5_2: "7",
        n5_3: "321030",
        n6: [],
        n7_1: "新潟",
        n7_3: false,
        n8_1: [],
        n8_2: "777",
        n8_3: false,
        n9: "1234",
        n10: [],
        n11: [],
        n12: "77",
        n13: "77",
        n14: "020202",
        n15_1: "01",
        n15_2: "02",
        n16: "010101",
        n17: [],
     },
      bbb: "hig",

    }
  },
  components: {
    PrintElement,
  },
  methods: {
    download() {
      //console.log(this.$refs.printaa.$el);

      createPdfFromHtml(this.$refs.printaa.$el);
    },

  },
  computed:{
    getlist(){
      return "";
      //return {x:PrintElement.data().n1[0].x, y:PrintElement.data().n1[0].y}
    }

  }
};
</script>

<style>
.pageout {
  position: fixed;
  top: 200vh;
}
.inputdata{
  font-family: -apple-system, "Segoe UI", "Helvetica Neue", "Hiragino Kaku Gothic ProN", メイリオ, meiryo, sans-serif;
  line-height: 11pt;
  color: red;
}

.n1, .n3, .n5, .n7, .n9, .n11, .n13, .n15 {
  color: rgb(46, 46, 46);
}
.n2, .n4, .n6, .n8, .n10, .n12, .n14, .n16 {
  color: rgb(46, 46, 46);
}

table{
  margin-left: 10px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue